import React from "react"
import style from "../../../css/checkbox.module.css"

/**
 * 
 * @param {, checked, text } param0 
 * @returns 
 */
const Checkbox = ({ checked, text }) => {
    return(
        <label className="flex items-center space-x-1">
            <div className={style.clCheckbox}>
                    <input type="checkbox" />
                    <span className=""></span>
            </div>
            <p className="block text-sm font-medium text-gray-700 text-left">{text}</p>
        </label>
    )
}

export default Checkbox